import axios from 'axios';
import { API_URL } from './baseApi';
import { IRefferalUser } from '../redux/selfRegistration/selfRegistrationTypes';

export const selfRegistrationApi = {
  createUser: async (user: IRefferalUser) => await axios.post(`${API_URL}/v3/self-registration`, { ...user }),
  getReward: async () => await axios.get(`${API_URL}/v3/self-registration/reward`),
};
